module.exports = __webpack_public_path__ + "fa-brands-400.e0fc4e5c719b4dc10c97";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/webfonts/fa-brands-400.ttf
// module id = ../../../../../src/scss/webfonts/fa-brands-400.ttf
// module chunks = styles